import { reskinStyles } from 'core/components/theme/theme-variant';
import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  link: {
    font: 'inherit',
    color: theme.colors.action_text,
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    textDecoration: 'underline',
    ...reskinStyles(theme, theme.actionStyles.link),
    '&:disabled': {
      color: theme.colorPalette.beige_70,
      cursor: 'default'
    }
  }
}));
